import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import App from './App';
import './App.css';

const container = document.getElementById('root');

// Fix for react-snap with React 18
if (navigator.userAgent === 'ReactSnap') {
  // Use legacy render for react-snap to ensure compatibility
  const root = document.getElementById('root');
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    root
  );
} else if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

function loadSalesmartlyScript(src) {
  return new Promise((resolve, reject) => {
    if (!src) return resolve();
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Failed to load salesmartly script'));
    document.head.appendChild(s);
  });
}

const SALES_SCRIPT = '';

loadSalesmartlyScript(SALES_SCRIPT).catch(() => {
  // ignore load errors — widget is optional
});